import Seo from "../components/site/Seo";
import { PageHero, Section } from "../components/site/Bits";
import DynamicForm from "../components/forms/DynamicForm";

export default function Collection() {
  return (
    <>
      <Seo title="Equipment Collection & Return" path="/equipment-return" description="Request collection of trial equipment in Melbourne and Victoria." />
      <PageHero eyebrow="Return equipment" title="Request equipment collection"
        intro="Finished a trial, or the equipment isn't right for you? Let us know and we'll book a collection time that suits you." />
      <Section><div className="max-w-4xl"><DynamicForm kind="collection" testid="collection-form" /></div></Section>
    </>
  );
}
